// extracted by mini-css-extract-plugin
module.exports = {"container":"views_container__3_3Yg","container1":"views_container1__UbzYL","iframe":"views_iframe__1foYb","text":"views_text__1NZnE","iframe1":"views_iframe1__1GbkW"};